import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';

@Injectable({
  providedIn: 'root'
})
export class DesignationService {
  constructor(private http: HttpClient) {}

  createDesignation(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createDesignation}`,
      payload
    );
  }

  getAllDesignations() {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllDesignations}`
    );
  }
  getDesignation(designationId) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getOneDesignation}/${designationId}`
    );
  }

  deleteDesignation(designationId) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteDesignation}/${designationId}`
    );
  }
  updateDesignation(designationId, payload) {
    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.updateDesignation}/${designationId}`,
      payload
    );
  }
}
